import { StandardEvents } from '@shopify/events';

const THRESHOLD_CENTS = 3000000;
let refreshTimer = null;
let activeRequest = 0;

function moneyFromCents(cents) {
  const amount = Math.max(0, Math.round(cents / 100));
  return `₡${new Intl.NumberFormat('es-CR', { maximumFractionDigits: 0 }).format(amount)}`;
}

function meterMarkup(cart) {
  const remaining = Math.max(0, THRESHOLD_CENTS - cart.total_price);
  const progress = Math.min(100, Math.max(0, (cart.total_price / THRESHOLD_CENTS) * 100));
  const unlocked = remaining <= 0;

  return {
    unlocked,
    html: `
      <div class="gigi-free-shipping__topline">
        <span class="gigi-free-shipping__label">ENVÍO GRATIS</span>
        <span class="gigi-free-shipping__threshold">desde ₡30.000</span>
      </div>
      <div class="gigi-free-shipping__message">
        ${
          unlocked
            ? '<strong>¡Listo! Tu compra ya tiene envío gratis.</strong>'
            : `Te faltan <strong>${moneyFromCents(remaining)}</strong> para desbloquearlo.`
        }
      </div>
      <div class="gigi-free-shipping__bar" aria-hidden="true">
        <span class="gigi-free-shipping__fill" style="width:${progress.toFixed(1)}%"></span>
      </div>
      ${unlocked ? '<div class="gigi-free-shipping__success">Beneficio aplicado al llegar al checkout.</div>' : ''}
    `,
  };
}

function buildMeter(cart) {
  const state = meterMarkup(cart);
  const meter = document.createElement('section');
  meter.className = `gigi-free-shipping${state.unlocked ? ' gigi-free-shipping--unlocked' : ''}`;
  meter.setAttribute('role', 'status');
  meter.setAttribute('aria-live', 'polite');
  meter.dataset.gigiFreeShipping = 'true';
  meter.innerHTML = state.html;
  return meter;
}

function updateMeter(meter, cart) {
  const state = meterMarkup(cart);
  meter.classList.toggle('gigi-free-shipping--unlocked', state.unlocked);
  meter.innerHTML = state.html;
}

function buildConfidenceStrip() {
  const strip = document.createElement('div');
  strip.className = 'gigi-cart-confidence';
  strip.dataset.gigiCartConfidence = 'true';
  strip.setAttribute('aria-label', 'Beneficios de comprar en GIGI');
  strip.innerHTML = `
    <span>✓ Compra segura</span>
    <span>✓ Envíos a todo Costa Rica</span>
    <span>✓ Retiro gratis en Grecia</span>
  `;
  return strip;
}

function polishCartCopy() {
  if (!document.querySelector('.cart-page')) return;

  document.querySelectorAll('.cart-page h1, .cart-page h2, .cart-page h3, .cart-page h4').forEach((heading) => {
    const text = (heading.textContent || '').trim().toLowerCase();
    if (text === 'cart') heading.textContent = 'Carrito';
    if (text === 'you may also like') heading.textContent = 'También te puede gustar';
  });

  document.querySelectorAll('.cart-page a, .cart-page button').forEach((control) => {
    const text = (control.textContent || '').trim().toLowerCase();
    if (text === 'view all') control.textContent = 'Ver más';
  });
}

function mountMeters(cart) {
  const totals = document.querySelectorAll('.cart-totals');

  totals.forEach((container) => {
    const existingMeter = container.querySelector('[data-gigi-free-shipping="true"]');
    const existingConfidence = container.querySelector('[data-gigi-cart-confidence="true"]');

    if (!cart || cart.item_count <= 0) {
      existingMeter?.remove();
      existingConfidence?.remove();
      return;
    }

    let meter = existingMeter;
    if (meter) {
      updateMeter(meter, cart);
    } else {
      meter = buildMeter(cart);
      const totalContainer = container.querySelector('.cart-totals__container');
      if (totalContainer) totalContainer.before(meter);
      else container.prepend(meter);
    }

    if (!existingConfidence) {
      const confidence = buildConfidenceStrip();
      meter.insertAdjacentElement('afterend', confidence);
    }
  });

  polishCartCopy();
}

async function refreshMeters() {
  const requestId = ++activeRequest;

  try {
    const response = await fetch(`${Theme.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) return;

    const cart = await response.json();
    if (requestId !== activeRequest) return;
    mountMeters(cart);
  } catch (_) {
    // Keep the cart usable even if the enhancement cannot refresh.
  }
}

function scheduleRefresh(delay = 40) {
  if (refreshTimer) window.clearTimeout(refreshTimer);
  refreshTimer = window.setTimeout(refreshMeters, delay);
}

function afterCartEvent(event) {
  if (event?.promise && typeof event.promise.finally === 'function') {
    event.promise.finally(() => scheduleRefresh(80));
  } else {
    scheduleRefresh();
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, afterCartEvent);
document.addEventListener(StandardEvents.cartDiscountUpdate, afterCartEvent);
window.addEventListener('pageshow', () => scheduleRefresh(0));

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => scheduleRefresh(0), { once: true });
} else {
  scheduleRefresh(0);
}

const observer = new MutationObserver((mutations) => {
  const relevant = mutations.some((mutation) => {
    const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
    if (target?.closest?.('[data-gigi-free-shipping="true"], [data-gigi-cart-confidence="true"]')) return false;

    return Boolean(
      target?.closest?.('#cart-drawer, .cart-page') ||
        Array.from(mutation.addedNodes).some(
          (node) =>
            node instanceof Element &&
            !node.matches?.('[data-gigi-free-shipping="true"], [data-gigi-cart-confidence="true"]') &&
            (node.matches?.('#cart-drawer, .cart-page, .cart-totals') || node.querySelector?.('.cart-totals'))
        )
    );
  });

  if (relevant) scheduleRefresh(70);
});

observer.observe(document.documentElement, { childList: true, subtree: true });
